import React, { useEffect, useMemo } from 'react'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'
import { useNavigate } from 'router'
import { useTranslation } from 'react-i18next'
import { useTheme, useMediaQuery, Box } from '@mui/material'
import { SideContent } from 'components-shared'
import SlideInModal from 'components/Modal/SlideInModal'
import Loading from 'components/global/Loading'
import CardH3 from './CardH3'
import CardStandard from './CardStandard'

const Card = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { apiSearch, isStandard } = useOutletContext()
  const navigate = useNavigate()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  useEffect(() => {
    if (isNaN(+id)) {
      navigate({ pathname: '..' })
    }
  }, [id, navigate])

  const localDateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }

  const coupon = useMemo(() => {
    if (!apiSearch.data?.coupons) return null
    return apiSearch.data.coupons.find(c => c.id === id)
  }, [apiSearch.data, id])

  const handleClose = () => {
    navigate({ pathname: '..' })
  }

  const cardContent = (
    <>
      {coupon ? (
        isStandard ? (
          <CardStandard 
            id={id} 
            localDateOptions={localDateOptions} 
            coupon={coupon}
            isModal={!isLargeScreen}
          />
        ) : (
          <CardH3 
            id={id} 
            localDateOptions={localDateOptions} 
            coupon={coupon}
            isModal={!isLargeScreen}
          />
        )
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Loading />
        </Box>
      )}
    </>
  )

  if (isLargeScreen) {
    return (
      <SideContent>
        {cardContent}
        <Outlet context={{ apiSearch, isStandard }} />
      </SideContent>
    )
  }

  return (
    <>
      <SlideInModal
        title={t('coupons.card.title')}
        icon={<i className="fa-regular fa-wifi" />}
        onClose={handleClose}
        width={isSmallScreen ? '100%' : '500px'}
        fullScreen={isSmallScreen}
      >
        {cardContent}
      </SlideInModal>
      <Outlet context={{ apiSearch, isStandard }} />
    </>
  )
}

export default Card
